import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWifi } from '@fortawesome/free-solid-svg-icons';

export default function NoInternet() {
  const [retrying, setRetrying] = useState(false);

  const onRetry = async () => {
    setRetrying(true);
    // Force a tiny network probe; if we're really online the 'online' event fires soon after.
    try {
      await fetch('/manifest.webmanifest', { cache: 'no-store' });
    } catch {
      /* ignore */
    }
    setTimeout(() => setRetrying(false), 600);
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 28,
        zIndex: 9998,
      }}
    >
      <div
        style={{
          backgroundColor: '#0f172a',
          border: '1px solid #233147',
          borderRadius: 20,
          padding: 32,
          width: '100%',
          maxWidth: 420,
          textAlign: 'center',
        }}
      >
        <FontAwesomeIcon icon={faWifi} style={{ color: '#f59e0b', fontSize: 48 }} />
        <div style={{ color: '#f8fafc', fontSize: 20, fontWeight: 900, marginTop: 16 }}>No Internet</div>
        <div style={{ color: '#94a3b8', fontSize: 14, marginTop: 8, marginBottom: 24, lineHeight: 1.5 }}>
          You're offline. Check your connection and try again.
        </div>
        <button
          disabled={retrying}
          onClick={onRetry}
          style={{
            backgroundColor: '#14f1d1',
            color: '#020617',
            border: 'none',
            padding: '12px 28px',
            borderRadius: 999,
            fontSize: 14,
            fontWeight: 800,
            cursor: retrying ? 'default' : 'pointer',
            opacity: retrying ? 0.6 : 1,
          }}
        >
          {retrying ? 'Checking…' : 'Retry'}
        </button>
      </div>
    </div>
  );
}
